export const API_BASEURL = 'https://inqueritos.clientesb2b.telecom.pt/api/v1'
export const DOMAIN = 'inqueritos.clientesb2b.telecom.pt'
export const DEBUG = false
export const ENV = 'Production'
export const API_KEY = 'e93135d6878713d164def6587eb0130807b17c2a'
export const PRODUCTION = true
